import { KeyScale } from '../axis/key/KeyScale.js';
import { ValueScale } from '../axis/value/ValueScale.js';
import { bounds } from '../types.js';
export const getBoundary = (keyScale: KeyScale, valueScale: ValueScale): bounds => {
  const {
    left,
    right
  } = keyScale.bounds;
  const {
    top,
    bottom
  } = valueScale.bounds;
  return {
    left,
    right,
    top,
    bottom
  };
};